import Router from 'next/router';

import prepareHref from '../prepareHref';

const setQueryParams =
  (brand) =>
  (params, type = 'push') => {
    if (!window) {
      return;
    }

    const { router } = Router;

    const { href: hrefObject, as } = prepareHref(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          ...params,
        },
      },
      brand
    );

    Router[type](hrefObject, as, { shallow: true });
  };

export default setQueryParams;
